import React from 'react';

import { getImgixSrc } from '@utils/images';

import MobileStepWithMedia from '../MobileStepWithMedia';
import { DeepResearchSection, SearchSection } from '../Steps/DeepResearchAndSearch';

interface DeepResearchAndSearchProps {
  handleClose: () => void;
  handleNext: () => void;
  isProSubscriber: boolean;
  step: number;
  totalSteps?: number;
}

const DEEP_RESEARCH_IMAGE_SRC = getImgixSrc({
  path: 'tooltip/deep_research.png',
  isEnvDependent: false,
});

const SEARCH_IMAGE_SRC = getImgixSrc({
  path: 'tooltip/search.png',
  isEnvDependent: false,
});

const DeepResearchAndSearch = ({
  handleClose,
  handleNext,
  isProSubscriber,
  step,
  totalSteps = 5,
}: DeepResearchAndSearchProps) => {
  const mediaSrc = isProSubscriber ? DEEP_RESEARCH_IMAGE_SRC : SEARCH_IMAGE_SRC;
  const contentBelowMedia = isProSubscriber ? (
    <div className="flex flex-col gap-16">
      <DeepResearchSection showUpgradeLink={false} />
      <SearchSection />
    </div>
  ) : (
    <div className="flex flex-col gap-16">
      <SearchSection />
      <DeepResearchSection showUpgradeLink />
    </div>
  );

  return (
    <MobileStepWithMedia
      contentBelowMedia={contentBelowMedia}
      handleClose={handleClose}
      handleNext={handleNext}
      isProSubscriber={isProSubscriber}
      media={
        <img
          src={mediaSrc}
          alt={isProSubscriber ? 'Deep Research' : 'Search'}
          className="h-full w-full object-cover object-top"
        />
      }
      showCloseButton={true}
      step={step}
      totalSteps={totalSteps}
    />
  );
};

export default DeepResearchAndSearch;
